import Head from 'next/head';

const PageHead = ({ title, description, path, locale, localizations, isPreview }) => {
  // For Czech pages, always use clean path without /cs prefix for canonical
  let canonicalPath = path || '/';
  if (locale === 'cs') {
    canonicalPath = path || '/';
  } else {
    canonicalPath = `/${locale}${path || '/'}`;
  }

  const canonicalUrl = `${process.env.NEXT_PUBLIC_SITE_URL}${canonicalPath}`;

  // Build alternate language URLs
  const alternateUrls = [
    {
      hreflang: locale || 'cs',
      href: canonicalUrl
    }
  ];

  // Add localizations if available
  (localizations || []).forEach((localization) => {
    const localizedPath = localization.path;
    const localizedLocale = localization.locale;

    let localizedUrl;
    if (localizedLocale === 'cs') {
      localizedUrl = `${process.env.NEXT_PUBLIC_SITE_URL}${localizedPath}`;
    } else {
      localizedUrl = `${process.env.NEXT_PUBLIC_SITE_URL}/${localizedLocale}${localizedPath}`;
    }

    alternateUrls.push({
      hreflang: localizedLocale,
      href: localizedUrl
    });
  });

  return (
    <Head>
      {/* Language meta */}
      <html lang={locale || 'cs'} />

      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Prevent indexing of preview pages */}
      {isPreview && <meta name="robots" content="noindex, nofollow" />}

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Language alternates */}
      {alternateUrls.map(({ hreflang, href }) => (
        <link key={hreflang} rel="alternate" hrefLang={hreflang} href={href} />
      ))}

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
    </Head>
  );
};
export default PageHead;
